import React from 'react';

const BusinessUnitConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/organizationalsetup/sourcenames',
			component:React.lazy(() => import('./SourceNames')) 
        }
	]
};

export default BusinessUnitConfig;